import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { translations } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Heritage } from "@/components/Heritage";
import { Process } from "@/components/Process";
import { Gallery } from "@/components/Gallery";
import { Commissions } from "@/components/Commissions";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { FloatingCTA } from "@/components/FloatingCTA";

function App() {
  const [lang, setLang] = useState(() =>
    (navigator.language || "en").toLowerCase().startsWith("it") ? "it" : "en"
  );
  const t = translations[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1 && document.querySelector(id)) {
        e.preventDefault();
        lenis.scrollTo(id, { immediate: true, offset: -88 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#F5F2EC] min-h-screen font-sans">
      <Navbar t={t} lang={lang} setLang={setLang} />
      <main>
        <Hero t={t} />
        <Marquee items={t.marquee.items} />
        <Process t={t} />
        <Heritage t={t} />
        <Commissions t={t} />
        <Gallery t={t} />
        <QuoteForm t={t} lang={lang} />
      </main>
      <Footer t={t} />
      <FloatingCTA t={t} />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
